<template>
	<div>
		<!-- Headline -->
		<div slot="headline" class="fs5 lh125 fw7 c1 mb2">
			{{ $t("insured_objects") }}
		</div>

		<!-- List -->
		<div v-for="insured in list" :key="insured.id">
			<core-entity-card :entity="insured" :isExpanded="false" class="mb2" />
		</div>

		<!-- Empty state -->
		<j-card v-if="list.length === 0" class="bg5 p2 ta2 fs3">{{
			$t("errors.no_data")
		}}</j-card>
	</div>
</template>

<script>
import CoreEntityCard from "@/modules/core/components/CoreEntityCard"
import JCard from "@/components/JCard"

export default {
	components: {
		CoreEntityCard,
		JCard
	},

	props: {
		list: {
			type: Array,
			required: true,
			default: () => []
		}
	}
}
</script>
